var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorize"},[_c('router-link',{attrs:{"role":"button","to":{ name: _vm.ROUTE_SHARE_BINDING, params: { hash: this.hash } },"replace":""}},[_vm._v("授权我们获取您的基本信息")]),_vm._v(" "),_c('div',{staticClass:"text-tip"},[_vm._v("我们现在对您一无所知，必须先获取您的基本信息，才能可能为您预约到任同政教练的课时")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7aab3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/Start.vue
// module id = null
// module chunks = 